module.exports = __webpack_public_path__ + "images/FUSA_icons/010-auction.88e94fc59b4ac4e2fae73eafc923153d.svg";